module.exports = __webpack_public_path__ + "static/img/cace-text.b1ec500f.png";